import React from 'react';

import Button from '../Button/Button';

import styles from './EmptyTable.module.scss';

const EmptyTable = ({ icon: Icon, title, callToAction, callToActionIcon: CATIcon, callToActionTitle }) => (
  <div className={styles.emptyContainer}>
    <Icon />
    <div>{title}</div>
    {!!callToActionTitle && (
      <Button className={styles.emptyCATBtn} onClick={callToAction}>
        {!!CATIcon && <CATIcon />}
        {callToActionTitle}
      </Button>
    )}
  </div>
);

export default EmptyTable;
